<div role="banner">
  <div class="toolbar">
    <img
      alt="SE Logo"
      class="logo"
      width="108"
      height="42"
      src="/assets/images/Siemens_Energy_logo_BG_white.svg.png"
      routerLink="/key-metrics"/>
    <span class="header-font"> Strategic Pricing </span>
    <div class="spacer"></div>
    <div class="action-buttons">
      <div class="businessAreaSelector">
        <div class="businessAreaSelector__container">
          <label for="businessArea" class="text-small-roman"
            >Select a Business Area</label
          >
          <p-dropdown
            id="businessArea"
            *ngIf="userGroups.length > 0"
            [options]="userGroups"
            [(ngModel)]="selectedBusinessArea"
            (ngModelChange)="changeBusinessArea($event)"
            placeholder="Select a Business Area"
            required="true" />
        </div>
      </div>
      <p-button
        styleClass="btn-rounded-primary"
        (click)="openSidebar()"
        [rounded]="true"
        icon="pi pi-heart"
        severity="help">
        <ng-template pTemplate="iconTemplate">
          <img
            src="/assets/images/user.svg"
            style="margin-bottom: 8px"
            alt="user" />
        </ng-template>
      </p-button>
    </div>
  </div>

  <div class="col-12 custom-nav">
    <div class="nav-panel">
      <ul class="nav nav-pills">
        <li class="nav-item">
          <a
            routerLink="/key-metrics"
            routerLinkActive="active"
            class="nav-link"
            aria-current="page"
            >Key Metrics</a
          >
        </li>
        <li class="nav-item">
          <a
            routerLink="/recommended-prices"
            [class.active]="isLinkActive('/recommended-prices')"
            class="nav-link"
            >Recommended Prices</a
          >
        </li>
        <li class="nav-item">
          <a
            routerLink="/pricing-history"
            [class.active]="isLinkActive('/pricing-history')"
            class="nav-link"
            >Pricing History</a
          >
        </li>        
        <li class="nav-item__settings" *ngIf="showSettingsPage">
          <a
            routerLink="/settings"
            [class.active]="isLinkActive('/settings')"
            class="nav-link"
            >Settings</a
          >
        </li>
      </ul>
    </div>
  </div>
</div>
